import { API_URL } from "./Config";
import { PageResult } from "./Pagination";
import { IDetailsResponse } from "./IDetailsResponse";
import { GetLicenseDetailsAsync } from "./LicenceDetails";
import { formatDate } from "./DateUtils";

export interface IChangeRequestRow {
  licencechangerequestid: string;
  licenceid: string;
  casenumber: string;
  status: string;
  title: string;
  epainiciated: string;
  requestdate: string;
  issueddate: string;
}

export interface IChangeRequestDetails extends IDetailsResponse {
  licencechangerequestid: string;
  licenceid: string;
  casenumber: string;
  status: string;
  title: string;
  epainiciated: string;
  requestdate: string;
  issueddate: string;
  licence_regno: string;
}

export interface IChangeRequestsList extends PageResult {
  list: IChangeRequestRow[];
}

export const GetLicenceChangeRequestsByLicenceFetchUrl = (
  licence_id: string,
  pageNo: number,
  recordsPerPage: number,
  searchText: string,
  filters: any
) => {
  var params = `&page=${pageNo}&per_page=${recordsPerPage}`;

  if (filters) {
    for (var i = 0; i < filters.length; i++) {
      var f = filters[i];
      let filterId = f.id;
      params += `&${filterId}=${f.value}`;
    }
  }

  if (searchText.length > 0) {
    params += `&search_term=${encodeURIComponent(searchText)}`;
  }

  let url = `${API_URL}/LicenceChangeResquest/filteredlistbyla?lic_id=${licence_id}${params}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/licence-change-requests-list`;
  }

  return url;
};

export interface IChangeRequestGridFilterValue {
  name: string;
  value: string;
}

export interface IChangeRequestsGridFilterValueList {
  count: number;
  list: IChangeRequestGridFilterValue[];
}

export async function GetChangeRequestStatusesAsync(): Promise<IChangeRequestsGridFilterValueList> {
  let url = `${API_URL}/LicenceChangeResquest/lcrstatusfilter`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/licence-change-request-statuses`;
  }

  var response = await fetch(url);
  var body = <IChangeRequestsGridFilterValueList>await response.json();
  body.list = body.list.map((item) => {
    return <IChangeRequestGridFilterValue>{
      name: item.name,
      value: item.value,
    };
  });
  return body;
}

export async function GetChangeRequestDetailsAsync(
  changeRequestId: string
): Promise<IChangeRequestDetails> {
  var url = `${API_URL}/LicenceChangeResquest/byid?lcr_id=${changeRequestId}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/licence-change-request-details`;
  }

  var response = await fetch(url);
  var body = <IChangeRequestDetails>await response.json();

  const licenceDetails = await GetLicenseDetailsAsync(body.licenceid);

  return <IChangeRequestDetails>{
    response: response,
    licencechangerequestid: body.licencechangerequestid,
    licenceid: body.licenceid,
    casenumber: body.casenumber,
    status: body.status,
    title: body.title,
    epainiciated: body.epainiciated,
    requestdate: formatDate(body.requestdate),
    issueddate: formatDate(body.issueddate),
    licence_regno: licenceDetails.reg_no,
  };
}
